import httpService from './httpService';
import { researchListUrl } from '../constants/apiEndPoints';

export function listResearchesAPI(offset) {
    return httpService.get(researchListUrl(offset));
}
